<div class="state-container" [class.page]="isPageSection">
  <ng-container [ngSwitch]="state">
    <ng-container *ngSwitchCase="SectionState.Loading">
      <div class="state background fade-in" [class.ready-s]="transparentBackground">
        <app-spinner></app-spinner>
        <div *ngIf="loadingLabel" class="loadin-text">
          <span class="ellipsis">{{ loadingLabel }}</span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="SectionState.Disconnected">
      <div class="state background problematic fade-in" [class.ready-s]="transparentBackground">
        <!-- @rehab:i didn't find any error icon in the app will ask menna to provide us one -->
        <div class="error-icon" *ngIf="false">
          <img src="/assets/images/error-state.svg" alt="error-icon.svg" />
        </div>
        <div class="error-message">
          <span>Connection was broken while loading</span>
        </div>
        <div class="try-again" (click)="onReload()">Try Again</div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="SectionState.Error">
      <div class="state background problematic fade-in" [class.ready-s]="transparentBackground">
        <div class="error-icon" *ngIf="false">
          <img src="/assets/images/error.svg" />
        </div>
        <div *ngIf="errorStateLabel" class="error-message">
          <span>{{ errorStateLabel }}</span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="SectionState.Empty">
      <div class="state background empty fade-in" [class.flexible-height]="flexibleHeight">
        <app-avatar *ngIf="emptyStateIcon; else emptyStateImage" matCardAvatar [round]="true" bgColor="var(--color-accent-lighter)" fgColor="var(--color-accent)"
        iconType="svg" [icon]="emptyStateIcon" [radius]="20" [size]="48" [iconSize]="'md'"
        iconColorClass="var(--color-accent)">
      </app-avatar>
      <ng-template #emptyStateImage>
        <img [src]="emptyStateImagePath || 'assets/images/empty-state.svg'" />
      </ng-template>
        <div class="empty-message">
          <h6 class="main-text weight-normal">{{ emptyStateMainLabel }}</h6>
          <p class="sub-text small">{{ emptyStateSubLabel }}</p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="SectionState.ComingSoon">
      <div class="state background coming-soon fade-in">
        <div class="coming-soon-icon">
          <img src="/assets/images/coming-soon-state.svg" />
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="SectionState.SearchResultEmpty">
      <div class="state background search-result-empty fade-in">
        <div class="search-result-empty-icon">
          <img src="/assets/images/search-result-empty-state.svg" />
        </div>
        <div class="search-result-empty-message">
          <h6 class="main-text weight-normal">{{ "SectionState.SearchResultEmptyStateMainLabel" | translate }}</h6>
          <p class="sub-text small">{{ "SectionState.SearchResultEmptyStateSubLabel" | translate}}</p>
        </div>
        <button *ngIf="showClearButton" mat-raised-button class="btn-secondary btn" (click)="onClearButtonClicked()">{{ "Buttons.Clear" | translate }}</button>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        state === SectionState.Ready ||
        state === SectionState.LoadingTransparent
      "
    >
      <div *ngIf="state === SectionState.LoadingTransparent" class="background transparent" [class.flexible-height]="flexibleHeight">
        <app-spinner></app-spinner>
        <div *ngIf="loadingLabel" class="loadin-text">
          <span class="ellipsis">{{ loadingLabel }}</span>
        </div>
      </div>
      <div class="fade-in state-section__content" [class.ready-s]="transparentBackground" [class.active]="SectionState.Ready">
        <ng-content></ng-content>
      </div>
    </ng-container>
  </ng-container>
</div>
